<template>
  <div class="main">
    <div class="gong_neng">
      <el-button @click="goPage">返回</el-button>
      <div class="block" style="margin-top: 10px">
        <el-cascader
          v-model="radar_list_value"
          :options="radar_list_city"
          @change="handleChange"
        ></el-cascader>
      </div>

      <el-button
        @click="is_shai = !is_shai"
        v-if="
          is_shaiXuan.indexOf($route.query.src) == -1 &&
          ['all_agent_clue', 'all_agent_resume'].indexOf($route.query.src) ==
            -1 &&
          $route.query.src != 'radar_list'
        "
        >筛选</el-button
      >
      <el-button
        style="margin-top: 10px"
        @click="is_shai_agent = !is_shai_agent"
        v-if="
          $cookies.get('auth_grade') == 80 && $route.query.src == 'radar_list'
        "
        >筛选</el-button
      >
      <el-button class="recharge" v-show="show" @click="recharge_record"
        >充值记录</el-button
      >
    </div>
    <div>
      <el-table
        v-if="$route.query.src != 'seed_user'"
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
        :row-class-name="tableRowClassName"
        @cell-click="cellClick"
      >
        <el-table-column
          v-for="(item, index) in title"
          :key="index"
          :prop="item.field"
          :label="item.name"
        >
        </el-table-column>
        <template
          v-if="
            $route.query.src == 'all_company' &&
            ($cookies.get('auth_grade') == 80 ||
              $cookies.get('auth_grade') == 60)
          "
        >
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                type="warning"
                @click="
                  $router.push({
                    path: '/recruitmentData',
                    query: {
                      id: scope.row.user_detail_id,
                      name: scope.row.company_name,
                    },
                  })
                "
              >
                数据看板</el-button
              >
            </template>
          </el-table-column>
        </template>
      </el-table>

      <el-table
        v-else
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
        :row-class-name="tableRowClassName"
        @cell-click="cellClick"
      >
        >
        <el-table-column
          v-for="(item, index) in title"
          :key="index"
          :prop="item.field"
          :label="item.name"
        >
          <template slot-scope="scope">
            <span
              v-if="item.field == 'recharge_amount'"
              class="pay"
              @click="payCha(scope.row.user_detail_id)"
              >{{ scope.row.recharge_amount }}
            </span>
            <span v-else class="">{{ scope.row[item.field] }} </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :total="total"
        :page-size="pagesize"
        hide-on-single-page
        :current-page="currentPage1"
      ></el-pagination>
    </div>
    <el-dialog
      title="筛选"
      :visible.sync="is_shai_agent"
      width="30%"
      :before-close="
        () => {
          is_shai_agent = false;
          form = {};
        }
      "
    >
      <el-form :model="form">
        <el-form-item label="公司名称" v-if="$route.query.src == 'radar_list'">
          <el-select
            v-model="form.user_detail_id"
            placeholder="请选择公司名称"
            filterable
          >
            <el-option
              v-for="item in options_company"
              :key="item.jd_id"
              :label="item.license_company_name"
              :value="item.user_detail_id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="筛选职位" v-if="$route.query.src == 'radar_list'">
          <el-select
            v-model="form.position"
            placeholder="请选择筛选职位"
            filterable
          >
            <el-option
              v-for="item in options_position"
              :key="item.jd_id"
              :label="item.jd_name"
              :value="item.jd_id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button type="primary" @click="list">重置</el-button> -->
        <el-button
          @click="
            () => {
              is_shai_agent = false;
              form = {};
              list();
            }
          "
          >清 空</el-button
        >
        <el-button type="primary" @click="shaiYes_agent">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="筛选"
      :visible.sync="is_shai"
      width="30%"
      :before-close="
        () => {
          is_shai = false;
          form = {};
        }
      "
    >
      <el-form :model="form" v-if="isShow.indexOf($route.query.src) >= 0">
        <el-form-item
          label="公司所在市"
          v-if="$cookies.get('auth_grade') != 90"
        >
          <el-input v-model="form.city_name"></el-input>
        </el-form-item>
        <el-form-item label="公司所在市" v-else>
          <el-select
            v-model="form.city_id"
            clearable
            placeholder="请选择所在市"
          >
            <el-option
              v-for="item in cityOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <!-- <el-form-item label="联系人">
          <el-input v-model="form.contact_name"></el-input>
        </el-form-item>-->
        <el-form-item label="账号">
          <el-input v-model="form.username"></el-input>
        </el-form-item>
        <el-form-item label="公司名称 ">
          <el-input v-model="form.license_company_name"></el-input>
        </el-form-item>
      </el-form>

      <el-form
        :model="form"
        v-else-if="
          ['login_in'].indexOf($route.query.src) >= 0 &&
          this.$cookies.get('auth_grade') == 100
        "
      >
        <el-form-item label="公司所在市">
          <el-input v-model="form.city_name"></el-input>
        </el-form-item>
        <el-form-item label="账号">
          <el-input v-model="form.username"></el-input>
        </el-form-item>
        <el-form-item label="是否充值客户">
          <!-- <el-input v-model="form.is_seed"></el-input> -->
          <el-select
            v-model="form.is_seed"
            placeholder="请选择是否充值客户"
            style="width: 100%"
            clearable
          >
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否体验客户">
          <!-- <el-input v-model="form.is_experience"></el-input> -->
          <el-select
            v-model="form.is_experience"
            placeholder="请选择是否体验客户"
            style="width: 100%"
            clearable
          >
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <el-form :model="form" v-else-if="$route.query.src == 'setting_resume'">
        <el-form-item label="简历期望地区">
          <el-input v-model="form.city_name"></el-input>
        </el-form-item>
      </el-form>
      <el-form :model="form" v-else>
        <el-form-item label="公司所在市">
          <el-input v-model="form.city_name"></el-input>
        </el-form-item>
        <el-form-item label="账号">
          <el-input v-model="form.username"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button type="primary" @click="list">重置</el-button> -->
        <el-button
          @click="
            () => {
              is_shai = false;
              form = {};
            }
          "
          >取 消</el-button
        >
        <el-button type="primary" @click="shaiYes">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { require } from "@/utils/http_request.js";

export default {
  data() {
    return {
      tableData: [],
      title: [],
      loading: true,
      pagesize: 15,
      currentPage1: 1,
      is_shai: false,
      form: {},
      isShow: [
        "all_company",
        "use_company",
        "pass_due_company",
        "seed_user",
        "pay_user",
        "experience_user",
      ], //筛选弹窗form的显示内容
      isShow1: [
        "login_in",
        "use_company",
        "pass_due_company",
        "seed_user",
        "pay_user",
        "experience_user",
      ], //筛选弹窗form的显示内容
      isHide: ["login_in", "setting_resume", "setting_company", "sign_in"], //筛选弹窗form的显示内容
      is_shaiXuan: ["setting_company", "sign_in"], //筛选按钮的显示
      cityOptions: [],
      total: 0,
      page: 0,
      options_company: [],
      form_agent: {},
      is_shai_agent: false,
      is_page: ["login_in"],
      options_position: [],
      show: false,
      radar_list_city: [],
      radar_list_value: "",
    };
  },
  created() {
    if (this.$route.query.src === "seed_user") {
      this.show = true;
    }
    if (this.$route.query.src == "radar_list") {
      require("post", "/commonality/v1/show_agent_place/", { is_add: 0 }).then(
        (res) => {
          if (res.code == 0) {
            this.radar_list_city = res.data;
            console.log(this.radar_list_city);
          }
        }
      );
    }

    this.list();
  },

  methods: {
    handleChange() {
      this.page = 0;
      this.currentPage1 = 1;
      this.radar_list_Fn();
    },
    radar_list_Fn() {
      let obj = {
        // token: this.$cookies.get("token"),
        username: this.$cookies.get("agent_username") || "",
        city_id:
          this.$route.query.type == "experience_user"
            ? this.$route.query.src
            : "",
        city_name:
          this.$route.query.type != "experience_user"
            ? this.$route.query.src
            : "",
        search_year: this.$route.query.date ? this.$route.query.date : "",
        search_data: {
          city_id: this.radar_list_value ? this.radar_list_value[1] : "",
        },
        page: this.page,
      };
      let url = "";
      if (this.$route.query.type == "experience_user") {
        url = "/lwbus_user/v1/lwbus_experience_user/";
      } else if (this.$route.query.type == "resume_clue") {
        url = "/lwbus_user/v1/lwbus_resume_clue/";
      } else if (this.$route.query.type == "resume_detail") {
        url = "/lwbus_user/v1/lwbus_resume_detail/";
      }
      if (this.form.position) {
        obj.search_data.jd_id = this.form.position;
      }
      require("post", url, obj).then((res) => {
        if (!res.code) {
          console.log(res);
          this.tableData = res.data.return_data;
          this.loading = false;
          this.title = res.data.title;
          this.total = res.data.user_count;
          this.is_shai = false;
          this.is_shai_agent = false;
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    //跳转到充值记录列表
    recharge_record() {
      this.$router.push({
        path: "/rechargerecord",
      });
    },
    tableRowClassName({ row, rowIndex }) {
      if (
        this.$route.query.src == "seed_user" &&
        row.is_agent_seed_user === 1
      ) {
        return "success-row";
      }
      if (this.$route.query.src == "pay_user" && row.expire == 1) {
        return "warning-row";
      }
      return "";
    },
    payCha(id) {
      this.$router.push({
        path: "/payXQ",
        query: {
          id,
        },
      });
    },

    cellClick(row, column, cell, event) {
      let arr = [
        "radar_count",
        "off_online_count",
        "is_online_count",
        "jd_count",
      ];
      console.log(row.user_detail_id, column.property, cell, event);
      if (arr.indexOf(column.property) > -1) {
        this.$router.push({
          path: "/xiangQing",
          query: {
            id: row.user_detail_id,
            column: column.property,
          },
        });
      }
    },
    shaiYes() {
      let index = 0;
      let length = 0;
      for (var key in this.form) {
        console.log();
        length++;
        if (key == "is_seed" || key == "is_experience") {
          console.log(typeof this.form[key] === "string");
          if (this.form[key] == "" && typeof this.form[key] === "string") {
            index++;
            delete this.form[key];
          }
        } else {
          if (this.form[key] == "") {
            index++;
            delete this.form[key];
          }
        }
      }
      console.log(JSON.stringify(this.form) == "{}", index, length);
      // if (JSON.stringify(this.form) == "{}" || index == length) {
      //   console.log("为空");
      //   this.$message.warning("请输入筛选内容");
      //   return false;
      // }
      this.loading = true;
      this.list();
    },
    handleSizeChange(val) {
      this.pagesize = val;

      // this.currentPage1 = 1;
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage1 = val;
      this.page = val - 1;
      console.log(this.radar_list_value);
      if (this.radar_list_value) {
        this.radar_list_Fn();
      } else {
        this.list();
      }
      console.log(`当前页: ${val}`, this.currentPage1);
    },
    goPage() {
      this.$router.go(-1);
    },
    list() {
      console.log("筛选", this.form);
      if (this.$cookies.get("auth_grade") == 90) {
        require("post", "/hr24_index_data/v1/province_agent_city/", {}).then(
          (res) => {
            if (!res.code) {
              console.log(res);
              this.cityOptions = res.data;
            }
          }
        );
      }
      let obj = {
        // token: this.$cookies.get("token"),
        username: this.$cookies.get("agent_username") || "",
        city_id:
          this.$route.query.type == "experience_user"
            ? this.$route.query.src
            : "",
        city_name:
          this.$route.query.type != "experience_user"
            ? this.$route.query.src
            : "",
        search_year: this.$route.query.date ? this.$route.query.date : "",
        search_data: {
          city_id: this.radar_list_value ? this.radar_list_value[1] : "",
        },
        page: this.page,
      };
      let url = "";
      if (this.$route.query.type == "experience_user") {
        url = "/lwbus_user/v1/lwbus_experience_user/";
      } else if (this.$route.query.type == "resume_clue") {
        url = "/lwbus_user/v1/lwbus_resume_clue/";
      } else if (this.$route.query.type == "resume_detail") {
        url = "/lwbus_user/v1/lwbus_resume_detail/";
      }
      if (this.form.position) {
        obj.search_data.jd_id = this.form.position;
      }
      require("post", url, obj).then((res) => {
        if (!res.code) {
          console.log(res);
          this.tableData = res.data.return_data;
          this.loading = false;
          this.title = res.data.title;
          this.total = res.data.user_count;
          this.is_shai = false;
          this.is_shai_agent = false;
          console.log("测试" + this.isShow);
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    shaiYes_agent() {
      this.list();
    },
  },
};
</script>

<style scoped>
.el-table >>> .warning-row {
  background: rgb(240, 196, 196);
}
.main {
  margin-top: 46px;
  margin-left: 229px;
  background: #ffff;
  min-height: 70vh;
  margin-bottom: 20px;
  width: 80vw;

  border-radius: 4px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.08);
  padding: 50px;
}
.gong_neng {
  padding: 12px 0;
}
.page {
  padding: 12px 0;
}
.pay {
  color: rgb(3, 166, 241);
  cursor: pointer;
}
.main >>> .success-row {
  background: rgb(243, 210, 210);
}
.recharge {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/index/lwbus_city_company.vue